const initialState = {
  token: null,
  isError: false,
  isSuccess: false,
  searchResult: {},
  fetchByIdResult: {},
  areas: [],
  bases: [],
  errorMessages: [],
  searchParams:{},
  interviewCount: 0,
};

const reserveSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'reserve_session/SEARCH_DATA': {
      const payload = action.payload;
      return {
        ...state,
        searchResult: payload.result,
        searchParams: payload.params,
        isError: false,
        errorMessage: null,
      };
    }
    case 'reserve_session/SUCCESS_RESERVE_BY_ID': {
      const result = action.payload.result;
      return {
        ...state,
        fetchByIdResult: result,
        isError: false,
        isSuccess: false,
        errorMessage: null,
      };
    }
    case 'reserve_session/SUCCESS_RESERVE': {
      return {
        ...state,
        isSuccess: true,
      };
    }
    case 'FETCH_AREAS': {
      const result = action.payload.result;
      return {
        ...state,
        areas: result.areaList,
      };
    }
    case 'FETCH_BASES': {
      const result = action.payload.result;
      return {
        ...state,
        bases: result.bases,
      };
    }
    case 'reserve_session/SAVE_SEARCH_PARAMS': {
      const params = action.payload.params;
      return {
        ...state,
        searchParams: params,
      };
    }
    case 'reserve_session/SHOW_LOADING': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'reserve_session/FINISH_LOADING': {
      return {
        ...state,
        isLoading: false,
      };
    }
    case 'reserve_session/FETCH_ERROR': {
      const result = action.payload.result;
      console.debug('errorMessages', result.message);
      return {
        ...state,
        isError: true,
        errorMessage: result.message,
      };
    }
    case 'reserve_session/FETCH_INTERVIEW_COUNT_SUCCESS': {
      const result = action.payload;
      return {
        ...state,
        interviewCount: result,
      };
    }
    default:
      return state;
  }
};

export { reserveSessionReducer as default };
